module.exports = __webpack_public_path__ + "img/生产-车床刀片.2f828b37.jpg";